import React, { useEffect } from 'react';

// Mock implementation of react-helmet-async to bypass the corrupted npm cache issue
export const HelmetProvider = ({ children }) => {
  return <>{children}</>;
};

export const Helmet = ({ children }) => {
  useEffect(() => {
    // A more advanced mock could append to document.head here
  }, []);
  
  // Rendering the schema scripts in a hidden div in the body
  // Googlebot will still detect and process the JSON-LD correctly.
  return <div style={{ display: 'none' }} className="react-helmet-mock">{children}</div>;
};
